<template>
	<div class="intro-header" id="homepage">
		<div class="container">
			<div class="row">
				<div class="col-lg-12">
					<!-- <div class="bottom-triangle"></div> -->
					<div class="intro-message">
						<div
							class="avatar d-inline-block animate__animated animate__pulse animate__infinite"
						>
							<a>
								<img src="@/assets/ritesh.jpeg" alt="Skytsunami" />
							</a>
						</div>
						<h1 class="animated bounceInDown">Ritesh Parmar</h1>
						<h3 class="animated lightSpeedIn">
							Full-Stack Developer
						</h3>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped>
.icon {
	margin-right: 10px;
	color: white;
}

.icon-one {
	position: absolute;
	bottom: 27%;
	left: 20%;
	margin-top: 40px;
	color: white;
	margin-right: 10px;
}

.icon-two {
	position: absolute;
	bottom: 27%;
	left: 48%;
	margin-top: 40px;
	color: white;
	margin-right: 10px;
}

.icon-three {
	position: absolute;
	bottom: 27%;
	right: 20%;
	margin-top: 40px;
	color: white;
	margin-right: 10px;
}

#scale:hover {
	-moz-transform: scale(1.1);
	-webkit-transform: scale(1.1);
	transform: scale(1.1);
}

.intro-header {
	padding-top: 0px;
	padding-bottom: 0px;
	text-align: center;
	background: linear-gradient(
			rgba(18%, 67%, 98%, 0.75),
			rgba(18%, 67%, 98%, 0.85)
		),
		url("https://mir-s3-cdn-cf.behance.net/project_modules/max_3840/7823cc45224441.5829e88f95dfa.png")
			no-repeat center center;
	background-size: cover;
}

.bottom-triangle {
	position: absolute;
	bottom: -40px;
	left: 25%;
	height: 30%;
	width: 50%;
	background: #65ce9b;
	-webkit-clip-path: polygon(50% 43%, 0% 100%, 100% 100%);
	clip-path: polygon(50% 43%, 0% 100%, 100% 100%);
}

.intro-message {
	position: relative;
	padding-top: 20%;
	padding-bottom: 20%;
}

.intro-message > h1 {
	color: white;
	font-weight: 100;
	font-size: 68px;
}

.intro-message > h3 {
	color: white;
	font-size: 24px;
	margin-top: 20px;
}

#button {
	color: white;
	font-size: 24px;
	margin-top: 30px;
	border: solid 6px white;
	background: #65ce9b;
	padding: 15px;
	text-transform: uppercase;
	font-weight: 500;
}

#button-two {
	color: white;
	font-size: 24px;
	margin-top: 10px;
	margin-bottom: 20px;
	border: solid 6px #ffffff;
	background: none;
	padding: 15px;
	text-transform: uppercase;
	font-weight: 500;
}

.avatar {
	width: 138px;
	height: 142px;
	box-sizing: border-box;
	border: 0px white solid;
	border-radius: 50%;
	overflow: hidden;
	box-shadow: 0 5px 15px 0px rgba(0, 0, 0, 0.6);
}
.avatar > a > img {
	width: 100%;
	height: auto;
}
</style>
